import { render, staticRenderFns } from "./_message_create_form.vue?vue&type=template&id=87a28cc6"
import script from "./_message_create_form.vue?vue&type=script&lang=js"
export * from "./_message_create_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports